"use client";

import { c as _c } from "react/compiler-runtime";
import { type FormEvent, useState } from "react";
import { useTranslation } from "react-i18next";
import { LEGACY_ICONS } from "@/components/shared/legacyIcons";
import { getApiErrorMessage, getHttpStatus } from "@/utils/apiError";
import { useLoginMutation } from "../hooks/useLoginMutation";
import { isTooManyAttempts } from "../utils/tooManyAttempts";
import { LoginAlert } from "./LoginAlert";
import { LoginInput } from "./LoginInput";
const INVALID_CREDENTIAL_STATUSES = [401, 422];
type LoginFormProps = {
  onLoggedIn: () => void;
  onForgotPassword: () => void;
};
export const LoginForm = t0 => {
  const $ = _c(46);
  const {
    onLoggedIn,
    onForgotPassword
  } = t0;
  const {
    t
  } = useTranslation("auth");
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const loginMutation = useLoginMutation();
  let t1;
  if ($[0] !== t) {
    t1 = error => {
      if (isTooManyAttempts(error)) {
        return t("tooManyAttempts");
      }
      const status = getHttpStatus(error);
      if (status !== undefined && INVALID_CREDENTIAL_STATUSES.includes(status)) {
        return t("login.invalidCredentials");
      }
      return getApiErrorMessage(error, t("common:feedback.requestError"));
    };
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getFailureMessage = t1;
  let t2;
  if ($[2] !== getFailureMessage || $[3] !== login || $[4] !== loginMutation || $[5] !== onLoggedIn || $[6] !== password || $[7] !== t) {
    t2 = event => {
      event.preventDefault();
      if (login.trim() === "" || password === "") {
        setErrorMessage(t("login.invalidCredentials"));
        return;
      }
      loginMutation.mutate({
        login,
        password
      }, {
        onSuccess: onLoggedIn,
        onError: error_0 => setErrorMessage(getFailureMessage(error_0))
      });
    };
    $[2] = getFailureMessage;
    $[3] = login;
    $[4] = loginMutation;
    $[5] = onLoggedIn;
    $[6] = password;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleSubmit = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setErrorMessage(null);
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== errorMessage) {
    t4 = <LoginAlert message={errorMessage} onClose={t3} />;
    $[10] = errorMessage;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t) {
    t5 = t("login.title");
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = <h3 className="mb-[25px] mt-5 text-2xl font-light leading-[1.1] text-[#eee]">{t5}</h3>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t) {
    t7 = t("login.identifier");
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== login || $[19] !== t7) {
    t8 = <div className="mb-[15px]"><LoginInput id="login" placeholder={t7} value={login} onValueChange={setLogin} icon={LEGACY_ICONS.user} /></div>;
    $[18] = login;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t) {
    t9 = t("login.password");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== password || $[24] !== t9) {
    t10 = <div className="mb-[15px]"><LoginInput id="password" type="password" placeholder={t9} value={password} onValueChange={setPassword} icon={LEGACY_ICONS.lock} /></div>;
    $[23] = password;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t) {
    t11 = t("login.forgotPassword");
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== onForgotPassword || $[29] !== t11) {
    t12 = <button type="button" onClick={onForgotPassword} className="h-[34px] rounded border border-[#e5e5e5] bg-[#e5e5e5] px-3 text-sm text-[#333] hover:border-[#c6c6c6] hover:bg-[#ccc]">{t11}</button>;
    $[28] = onForgotPassword;
    $[29] = t11;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  const t13 = loginMutation.isPending;
  let t14;
  if ($[31] !== t) {
    t14 = t("login.submit");
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== loginMutation.isPending || $[34] !== t14) {
    t15 = <button type="submit" disabled={t13} className="h-[34px] rounded border border-[#32c5d2] bg-[#32c5d2] px-3 text-sm text-white hover:border-[#2499a3] hover:bg-[#26a1ab] disabled:opacity-65">{t14}</button>;
    $[33] = loginMutation.isPending;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t12 || $[37] !== t15) {
    t16 = <div className="flex items-center justify-between pt-px">{t12}{t15}</div>;
    $[36] = t12;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== handleSubmit || $[40] !== t10 || $[41] !== t16 || $[42] !== t4 || $[43] !== t6 || $[44] !== t8) {
    t17 = <form noValidate={true} onSubmit={handleSubmit}>{t4}{t6}{t8}{t10}{t16}</form>;
    $[39] = handleSubmit;
    $[40] = t10;
    $[41] = t16;
    $[42] = t4;
    $[43] = t6;
    $[44] = t8;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
};